import { AxiosError } from 'axios';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export type VendorsAction = ActionType<typeof actions>;

export interface VendorsState {
  vendors: {
    data: Vendor[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  vendor: {
    data: Vendor | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export interface VendorParams {
  enterpriseId: string;
  vendorId?: string;
  vendor?: any;
  vendorEvaluation?: any;
  vendorEvaluationId?: string;
  filterData?: any;
}

export enum PQStatus {
  NOT_STARTED = '1',
  ACCEPTED = '2',
  DECLINED = '3',
  INVITED = '4',
  SUBMITTED = '5',
}

export const pqStatusKorean = {
  '1': '심사 전',
  '2': '승인',
  '3': '미승인',
  '4': '초대됨',
  '5': '제출완료',
} as const;

export enum VendorWorkerWageForm {
  DAILY_WAGE = '1',
  FREELANCER = '2',
}

export const vendorWorkerWageFormKorean = {
  '1': '일당',
  '2': '프리랜서',
} as const;

export enum SubmissionStatus {
  INVITED = '0',
  SUBMITTING = '1',
  SUBMITTED = '2',
  SUBMITTED_ON_BEHALF = '3',
  REJECTED = '4',
}

export enum VendorType {
  COMPANY = '1',
  WORKER = '2',
}

export const submissionStatusKorean = {
  '0': '초대됨',
  '1': '작성중',
  '2': '제출완료',
  '3': '대신제출',
  '4': '거절',
} as const;

export interface Vendor {
  id: number;
  enterprise?: any;
  qualificationStatus: PQStatus;
  submissionStatus: SubmissionStatus;
  score: number;
  type: VendorType;
  gongjong: string;
  category: string;
  description: string;
  expirationDate: string;
  comment: string;
  application: any;
  contactPoint: any;
  createdAt: string;
  updatedAt: string;
  evaluation: VendorEvaluation[];
  registrationEvaluation: any;
  attachedFiles: any[];
  receiverCompany: any;
  invoices: any[];
}

export interface VendorEvaluation {
  id: number;
  comment: string;
  user: any;
  createdAt: string;
}
